export default "__VITE_PUBLIC_ASSET__1bb109da__"